"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpdErrorsContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
exports.TpdErrorsContainer = styled_1.default.div `
    
    .tpd-errors {
        text-align: center;
        background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
        border: 1px solid ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$grey_border"]};
        float: none;

        i {
            color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$grey_border_form"]};
            font-size: 140px;
        }

        .box-error-content {
            padding: 30px 5px;
        }

        .add-margin-y {
            margin-top: 22px;
        }

        .tpd_error_component_button button {
            background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$medium-light-blue"]};
            border: none;
            color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
            display: inline-block;
            font-family: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$medium"]};
            font-size: 13px;
            height: 24px;
            height: 45px;
            line-height: 16px;
            line-height: 45px;
            margin-top: 20px;
            outline: transparent;
            padding: 2px 20px;
            position: relative;
        }

        .title {
            margin-top: 20px;
            color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$main_color"]};
            font-family: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$medium"]};
            font-size: 30px;
            line-height: 37px;
        }

        .subtitle {
            width: 100%;
            color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$main_color"]};
            font-size: 30px;
            font-family: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$normal"]};
            line-height: 37px;
            margin: 0 auto;
            margin-top: 10px;
        }

        .tpd_error_component_button button:hover {
            background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$medium-light-blue"]};
            opacity: 0.8;
        }
    }

    .tpd-errors.tpd-errors-blue {
        background-color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$main_color"]};
        border: none;

        .add-margin-y {
            margin-top: 0;
        }

        .title {
            margin-top: 0;
            color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$medium_blue"]};
            font-family: inherit;
            font-size: 22px;
            line-height: 22px;
        }

        .subtitle {
            width: 60%;
            color: ${nodejs_library_1.Styles.GlobalStyleVariables.widgetVariablesStyle["$light_blue"]};
            font-size: 20px;
            font-family: inherit;
            line-height: 20px;
            margin: 0 auto;
        }
    }

    ${nodejs_library_1.Styles.BreakpointsUtils.mobileOnly(`
        .tpd-errors {
            padding: 30px 0;
            min-height: 415px;
        }

        .tpd-errors.tpd-errors-pu {
            padding: 100px 0px;
        }
    `)}

    ${nodejs_library_1.Styles.BreakpointsUtils.tabletOnly(`
        .tpd-errors {
            min-height: 150px;
        }

        .tpd-errors.tpd-errors-pu {
            padding: 33px 0;
        }
    `)}

    ${nodejs_library_1.Styles.BreakpointsUtils.tabletOnly(`
        .tpd-errors {
            min-height: 150px;

            .box-error-content {
                padding: 0 5px;
            }
        }

        .tpd-errors.tpd-errors-pu {
            padding: 33px 0;
        }
    `)}
    
`;
